<template>
  <div class="page-main">
    <h4>可用资源</h4>
    <div></div>
    <h4>作业</h4>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      activeIndex: "1",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
   
  },
  created() {

  },
  mounted(){
    //todo 可用资源 作业运行首页数据获取
  }
};
</script>



// WEBPACK FOOTER //
// src/workspace/components/Resource.vue